import styled from "styled-components";
import axios from "axios";
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { baseURL } from "../../services/authentication.js";
import {useState} from 'react'






const Container=styled.div`
	border: 1px solid grey;
	border-radius:8px;
	margin:25px;
	display:flex;
	flex-direction:column;
	align-items:center;
	padding:10px
 `;

const Seccion=styled.div`
	padding:15px;
	width:94%;
	display:flex;
	align-items:center;
	justify-content:space-around;
	background-color:#F7F6F6;
	margin:5px;
	border-radius:8px;
`;



 export default function CreateRuta(){
		let [send,setSend]=useState(true)

 		let sendRuta=async()=>{

			
		try{			
				
				let nombreRutaCreate=document.getElementById("nombreRutaCreate").value;
				let descripcionRutaCreate=document.getElementById("descripRutaCreate").value;
					

				const form = new FormData();
				form.append("nombre",nombreRutaCreate);
				form.append("descripcion",descripcionRutaCreate);
					

				let datosCompletos=Object.fromEntries(form.entries());
				
				await axios.post(baseURL+'/rutas/',datosCompletos)
			 	.then(res=>{alert("ruta correctamente subida" )   })
			 	.catch((err) => (console.log("Error api: " + err)));
			

		}catch(err){alert("error al moneto de grabar la ruta"); console.log(err)}	



		
 		};

 	return(
 		<Container>
 				<div>Crear Ruta</div>
				<Seccion>
					<label>Nombre de la ruta</label>
					<TextField id="nombreRutaCreate" label="nombre" variant="outlined" placeholder="nombre de la ruta" disabled={send} fullWidth />
				</Seccion>
 				<Seccion>	
					<label>Descripcion de la ruta</label>
				<TextareaAutosize maxRows={10} minRows={5} id="descripRutaCreate"  placeholder="descripcion de la ruta" aria-label="maximum height"  style={{ width: 900 }} disabled={send} />
				</Seccion>
 				
				<Button variant="contained" loadingPosition="start" startIcon={<CloudUploadIcon />} loading={send} onClick={sendRuta} >subir</Button>	
 		</Container>


 		)
 }